<template>
    <div class="wrap-deposit">
        <h4>Deposit</h4>
        <section class="content-deposit">
            <div class="title">
                <h5>Daftar Deposit</h5>
                <button type="button" class="btn btn-primer" @click="showModal">Tambah</button>
            </div>
            <div style="overflow-x:auto">
                <table class="table">
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Nama</th>
                            <th>Platform</th>
                            <th>Bank</th>
                            <th>Jumlah</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(deposit, i) in deposits" :key="i" v-show="deposits.length > 0">
                            <td>{{ i + 1 }}</td>
                            <td>{{ deposit.account_name }}</td>
                            <td>
                                {{ deposit.platform.name }}
                            </td>
                            <td>{{ deposit.bank_name }}</td>
                            <td>{{ currencyFormat(deposit.amount) }}</td>
                            <td>
                                <span class="status" :class="{ success: deposit.status == 'accepted', warning: deposit.status == 'rejected' }">{{
                                    deposit.status
                                }}</span>
                            </td>
                            <td>
                                <b-button variant="outline-primary mr-2" size="sm" @click="showModalDetail(deposit, 'modalDetail')">Detail</b-button>
                                <b-button variant="outline-warning" size="sm" @click="showModalDetail(deposit, 'modal-1')" v-if="deposit.status == 'rejected'"
                                    >Edit</b-button
                                >
                            </td>
                        </tr>
                        <tr v-show="deposits.length == 0" class="text-center">
                            <td colspan="7">No Data Available in Table</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <b-modal title="Upload Deposit" ref="modal-1">
                <form>
                    <div class="form-group">
                        <label for="" class="label-form">Bank</label>
                        <input type="text" class="form-input" v-model="form.bank_name" readonly />
                    </div>
                    <div class="form-group">
                        <label for="" class="label-form">Nama Pemilik</label>
                        <input type="text" class="form-input" v-model="form.account_name" readonly />
                    </div>
                    <div class="form-group">
                        <label for="" class="label-form">No Rekening</label>
                        <input type="text" class="form-input" v-model="form.account_no" readonly />
                    </div>
                    <div class="form-group">
                        <label for="" class="label-form">Platform</label>
                        <select name="" id="" v-model="$v.form.platform_code.$model">
                            <option v-for="(platform, i) in platforms" :value="platform.code" :key="i">{{ platform.name }}</option>
                        </select>
                        <div v-if="$v.form.platform_code.$error">
                            <div class="form-error" v-if="!$v.form.platform_code.required">
                                Platform tidak boleh kosong
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="" class="label-form">Jumlah</label>
                        <input type="text" class="form-input" v-model="$v.form.amount.$model" />
                        <div v-if="$v.form.amount.$error">
                            <div class="form-error" v-if="!$v.form.amount.required">
                                Jumlah tidak boleh kosong
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="" class="label-form">Tanggal Deposit</label>
                        <input type="date" class="form-input" v-model="$v.form.deposit_date.$model" :max="today" />
                        <div v-if="$v.form.deposit_date.$error">
                            <div class="form-error" v-if="!$v.form.deposit_date.required">
                                Tanggal tidak boleh kosong
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="" class="label-form">Upload bukti transfer</label>
                        <label for="inputTag" class="upload-video">
                            <span v-if="!loadDataVideo"> <b-icon icon="upload" class="mr-1 icon-upload"></b-icon> Choose File </span>
                            <b-spinner small variant="ligth" v-else></b-spinner>
                            <input id="inputTag" type="file" accept="image/*" ref="image" @change="onFileImage" />
                        </label>
                        <span id="imageName" class="ml-3"> {{ label_image }}</span>
                        <div v-if="$v.form.image.$error">
                            <div class="form-error" v-if="!$v.form.image.required">
                                File tidak boleh kosong
                            </div>
                            <div class="form-error" v-if="!$v.form.image.imageRule">
                                Format file harus .jpg, .jpeg, dan .png
                            </div>
                        </div>
                    </div>
                </form>
                <template #modal-footer>
                    <button type="submit" class="btn btn-scondary" @click="$bvModal.hide('modal-1')">Cancel</button>
                    <button type="submit" class="btn btn-primer" @click="submitDeposit">
                        <span v-if="!isLoading"> Submit</span>
                        <b-spinner variant="light" small v-else style="width: 20px; height: 20px"></b-spinner>
                    </button>
                </template>
            </b-modal>
            <b-modal ref="modalDetail" title="Detail Deposit">
                <div class="d-block modal-detail" v-if="deposit">
                    <div>
                        <label class="label">Nama</label> <span> : </span> <span>{{ deposit.account_name }}</span>
                    </div>
                    <div>
                        <label class="label">Platform</label> <span> : </span> <span>{{ deposit.platform.name }}</span>
                    </div>
                    <div>
                        <label class="label">Bank</label> <span> : </span> <span>{{ deposit.bank_name }}</span>
                    </div>
                    <div>
                        <label class="label">No Rekening</label> <span> : </span> <span>{{ deposit.account_no }}</span>
                    </div>
                    <div>
                        <label class="label">Jumlah</label> <span> : </span> <span>{{ currencyFormat(deposit.amount) }}</span>
                    </div>
                    <div>
                        <label class="label">Tanggal Deposit</label> <span> : </span>
                        <span v-if="deposit.deposit_date">{{ deposit.deposit_date | formatDate }}</span>
                    </div>
                    <div>
                        <label class="label">Status</label> <span> : </span> <span>{{ deposit.status }}</span>
                    </div>
                    <div>
                        <label class="label">Deskripsi</label> <span> : </span> <span>{{ deposit.description }}</span>
                    </div>
                    <div>
                        <label class="d-block label">Bukti Transfer</label>
                        <b-spinner v-if="isLoadImgDetail"></b-spinner>
                        <img :src="imgDeposit" alt="Bukti Transfer" class="image" v-else />
                    </div>
                </div>
            </b-modal>
        </section>
    </div>
</template>

<script>
import Axios from "axios";
import moment from "moment";
import { helpers, required } from "vuelidate/lib/validators";

const imageRule = helpers.regex("image", /\.(gif|jpe?g|tiff|png)$/);

export default {
    data() {
        return {
            deposits: [],
            deposit: "",
            platforms: [],
            url: "https://api-kyc-abi-dev.abicommodity.co.id/v2/get/file",
            isLoading: false,
            loadDataVideo: false,
            isLoadImgDetail: false,
            today: "",
            label_image: "",
            status_deposit: "",
            id_customer: "",
            form: {
                customer_id: "",
                platform_code: "",
                bank_name: "",
                account_no: "",
                account_name: "",
                amount: "",
                deposit_date: "",
                image: "",
            },
            idCustomer: "",
            imgDeposit: "",
        };
    },
    validations: {
        form: {
            amount: {
                required,
            },
            platform_code: {
                required,
            },
            image: {
                required,
                imageRule,
            },
            deposit_date: {
                required,
            },
        },
    },
    mounted() {
        this.today = new Date().toISOString().split("T")[0];
        this.$store.dispatch("getCustomer").then((resCustomer) => {
            let id = resCustomer._id;
            this.idCustomer = id;
            localStorage.setItem("user", resCustomer.nickname);
            this.form.customer_id = id;
            this.id_customer = id;
            this.platforms = resCustomer.platform;
            this.form.account_no = resCustomer.bank_account[0].account_no;
            this.form.account_name = resCustomer.bank_account[0].account_name;
            this.form.bank_name = resCustomer.bank_account[0].name;
            Axios.get("/v2/kyc/deposit_confirmation?", {
                params: {
                    customer_id: id,
                },
            }).then((res) => {
                this.deposits = res.data.data.deposit_confirmation;
            });
        });
    },
    watch: {
        "form.amount"() {
            this.form.amount = this.currencyFormat(this.form.amount);
        },
    },
    methods: {
        currencyFormat(value) {
            return (value + "").replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        formatNumber(value) {
            return value.replace(/[^\d]/g, "");
        },
        showModal() {
            this.$refs["modal-1"].show();
            this.form.platform_code = "";
            this.form.amount = "";
            this.form.deposit_date = "";
            this.form.image = "";
            this.label_image = "";
        },
        onFileImage() {
            let image = this.$refs.image.files[0];
            this.label_image = "";
            this.loadDataVideo = true;
            if (image.type == "image/jpg" || image.type == "image/jpeg" || image.type == "image/png") {
                let formData = new FormData();
                formData.append("file", image);
                Axios.post("/v2/kyc/upload/" + this.idCustomer, formData).then((res) => {
                    this.loadDataVideo = false;
                    if (!res.data.data.iserror) {
                        this.label_image = image.name;
                        this.form.image = res.data.data;
                    }
                });
            }
        },
        submitDeposit() {
            this.$v.form.$touch();
            if (this.$v.form.$error) {
                return;
            }

            const data = {
                customer_id: this.form.customer_id,
                platform_code: this.form.platform_code,
                bank_name: this.form.bank_name,
                account_no: this.form.account_no,
                account_name: this.form.account_name,
                amount: this.formatNumber(this.form.amount),
                deposit_date: this.form.deposit_date,
                image: this.form.image,
            };

            this.isLoading = true;
            let method;
            if (this.status_deposit == "rejected") {
                method = {
                    url: "/v2/kyc/deposit_confirmation/" + this.id_customer,
                    method: "PUT",
                    data: data,
                };
            } else {
                method = {
                    url: "/v2/kyc/deposit_confirmation/",
                    method: "POST",
                    data: data,
                };
            }
            Axios(method)
                .then((res) => {
                    if (res.data.data.status_code == "00") {
                        this.isLoading = false;
                        this.$toast.success("Permintaan Deposit berhasil", {
                            position: "top-center",
                            timeout: 2000,
                            closeOnClick: true,
                            pauseOnFocusLoss: false,
                            pauseOnHover: false,
                            showCloseButtonOnHover: false,
                            hideProgressBar: false,
                            closeButton: "button",
                            icon: true,
                            rtl: false,
                        });
                        setTimeout(function() {
                            location.reload();
                        }, 2000);
                    }
                })
                .catch((error) => {
                    this.isLoading = false;
                    let status = error.response.data.data.status_code;
                    if (status == "1004") {
                        this.$toast.error("Permintaan Deposit sudah diisi", {
                            position: "top-center",
                            timeout: 2000,
                            closeOnClick: true,
                            pauseOnFocusLoss: false,
                            pauseOnHover: false,
                            showCloseButtonOnHover: false,
                            hideProgressBar: false,
                            closeButton: "button",
                            icon: true,
                            rtl: false,
                        });
                    }
                });
        },
        showModalDetail(value, modal) {
            this.deposit = value;
            this.$refs[modal].show();

            if (value) {
                this.id_customer = this.deposit._id;
                this.form.platform_code = this.deposit.platform.code;
                this.form.bank_name = this.deposit.bank_name;
                this.form.account_no = this.deposit.account_no;
                this.form.account_name = this.deposit.account_name;
                this.form.amount = this.deposit.amount;
                this.form.deposit_date = moment(this.deposit.deposit_date).format("YYYY-MM-DD");
                this.form.image = this.deposit.image;
                this.label_image = this.deposit.image;
                this.status_deposit = this.deposit.status;
                this.isLoadImgDetail = true;
                this.$store.dispatch("getImageAccess", this.deposit.image).then((res) => {
                    this.imgDeposit = res;
                    this.isLoadImgDetail = false;
                });
            }
        },
        hideModalDetail(idModal) {
            this.$refs[idModal].hide();
        },
    },
};
</script>

<style scoped>
.content-deposit {
    font-size: 14px;
    background-color: #fff;
    border-radius: 1rem;
    box-shadow: 0 0 2rem 0 rgb(136 152 170 / 13%);
    margin-top: 3rem;
}

.title {
    padding: 1rem;
    display: flex;
    justify-content: space-between;
}

.label-form {
    display: block;
}

.btn-primer,
.btn-scondary {
    font-size: 13px;
    width: unset;
    height: unset;
    padding: 0.5rem 1rem;
}

.form-error {
    font-size: 12px;
    color: #dc3545;
    margin: 0.5rem 0;
}

.form-input,
select {
    width: 100%;
    height: 2.5rem;
}

.status {
    font-weight: bold;
}

.status.success {
    color: #28a745;
}

.status.warning {
    color: #dc3545;
}

.upload-video {
    border: 1px solid #1f354a;
    padding: 0.5rem;
    color: #1f354a;
    border-radius: 5px;
    font-size: 13px;
    cursor: pointer;
    font-weight: bold;
}

.upload-video:hover {
    background: #1f354a;
    color: #ffffff;
}

.icon-upload {
    font-size: 19px;
}

#inputTag {
    display: none;
}

.image {
    width: 18rem;
}

.label {
    font-weight: bold;
    width: 9rem;
}
</style>
